@if (currentSurvey) {
    <div [ngClass]="templateStyleClass">
        <div class="card"
             data-test="survey-analysis-overview">
            <div class="card-header d-flex">
                <h2 class="card-title align-self-center">Overview</h2>
            </div>
            <div class="card-body d-flex flex-column flex-grow-1 gap-3">
                <h4>{{ currentSurvey!.name }} ({{ currentSurvey!.startTime | adaptDate }} &mdash; {{ currentSurvey!.endTime | adaptDate }})
                </h4>
                @if (currentSurvey!.surveyResults.length === 1) {
                    <adapt-display-survey-result [hideDate]="true"
                                                 [hideName]="true"
                                                 [survey]="currentSurvey"></adapt-display-survey-result>
                } @else {
                    <adapt-display-multi-group-survey-result [survey]="currentSurvey"></adapt-display-multi-group-survey-result>
                }
                @if (currentSurvey!.surveyResults.length === 1) {
                    <div class="flex-grow-1"
                         [class.display-categories-summary]="currentSurvey!.surveyType === SurveyType.OrganisationDiagnostic">
                        @if (surveyQuestions?.categoryIds) {
                            <adapt-display-categories-summary [survey]="currentSurvey"
                                                              [surveyQuestions]="surveyQuestions"></adapt-display-categories-summary>
                        } @else {
                            <adapt-display-survey-category-chart [survey]="currentSurvey"></adapt-display-survey-category-chart>
                        }
                    </div>
                }
            </div>
        </div>
        @if (currentSurvey!.surveyResults.length > 1 && surveyQuestions?.categoryIds) {
            <div class="card print-break-after">
                <div class="card-header">
                    <h2 class="card-title">
                        Scores by
                        {{ getAnalyseTargetLabel(currentSurvey!.surveyType) }}
                    </h2>
                </div>
                <div class="card-block m-3">
                    <adapt-display-categories-summary [survey]="currentSurvey"
                                                      [showTitle]="false"
                                                      [surveyQuestions]="surveyQuestions"></adapt-display-categories-summary>
                </div>
            </div>
        }
        @if (!surveyQuestions?.categoryIds) {
            @for (questionId of questionIds; track questionId) {
                <div class="card print-break-after"
                     data-test="question-analysis">
                    <div class="card-header">
                        <h2 class="card-title">Question {{ questionId }}</h2>
                    </div>
                    <div class="card-body">
                        <adapt-display-survey-question-stats [survey]="currentSurvey"
                                                             [maxResponseCount]="maxResponseCounts[questionId]"
                                                             (maxResponseCountChange)="onMaxResponseCountChanged($event, questionId)"
                                                             [surveyQuestions]="surveyQuestions"
                                                             [questionId]="questionId"></adapt-display-survey-question-stats>
                    </div>
                </div>
            }
        } @else {
            @for (categoryId of surveyQuestions?.categoryIds; track categoryId) {
                <div class="card print-break-after">
                    <div class="card-header">
                        <h2 class="card-title mt-3">
                            {{ surveyQuestions?.getCategory(categoryId)!.categoryName }}
                        </h2>
                    </div>
                    <div class="card-body">
                        <adapt-display-category-questions [survey]="currentSurvey"
                                                          [surveyQuestions]="surveyQuestions"
                                                          [otherSummaryHeight]="otherCategorySummaryHeights[categoryId]"
                                                          (summaryHeightChange)="categorySummaryHeightChanged(categoryId, $event)"
                                                          [categoryId]="categoryId"
                                                          [forceInitialise]="forceInitialise"></adapt-display-category-questions>
                    </div>
                </div>
            }
        }
    </div>
}
